module.exports = __webpack_public_path__ + "static/media/example-product.c231770d.svg";